import React from 'react';
import NhiemVuTTXM from './NhiemVuTTXM.jsx';
import moment from 'moment';
import { ShowIf } from 'components/utils';
import { Link, browserHistory } from 'react-router';
import { Text, TextMessage } from 'components/tt-forms/common';
import {ContainerFileDinhKem} from 'components/upload';
import ThongTinYeuCauKiemTraDeXuat from './ThongTinYeuCauKiemTraDeXuat.jsx';

class KetQuaGiaiQuyetDonTruongPhong extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      id: this.props.id,
      role: this.props.roleGQ,
      coQuanQuanLyNguoiDung: this.props.coQuanQuanLyNguoiDung,
      data: this.props.dataLichSuGiaiQuyet
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.id != nextProps.id && nextProps.id) {
      this.setState({
        id: nextProps.id,
        role: nextProps.roleGQ,
        coQuanQuanLyNguoiDung: nextProps.coQuanQuanLyNguoiDung,
        data: nextProps.dataLichSuGiaiQuyet
      })
    }
  }

  onClickClose() {
    if (typeof this.props.handleBack == 'function') {
      this.props.handleBack();
    } else {
      browserHistory.goBack();
    }
  }

  render() {
    return (
      <section className="wrap-block">
        <ShowIf condition={this.state.role == 'truongPhongTTXM'}>
          <NhiemVuTTXM
            donViGiaoThamTraXacMinh={this.props.donViGiaoThamTraXacMinhInfo}
            ngayBatDauTTXM={this.props.ngayBatDauTTXM}
            yKienCuaDonViGiaoTTXM = {this.props.yKienCuaDonViGiaoTTXM}
            ngayHetHanTTXM={this.props.ngayHetHanTTXM}
            donInfo={this.props.donInfo}
          />
        </ShowIf>
        <ShowIf condition={this.state.role == 'truongPhongKiemTraDeXuat'}>
          <ThongTinYeuCauKiemTraDeXuat
            listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDon}
            {...this.props.dataKiemTraDeXuat}
            donInfo={this.props.donInfo}
            />
        </ShowIf>
        <ShowIf condition={this.props.roleGQ !== "truongPhongGiaiQuyetDon"}>
          <div className="wrap-big-line pt5 pb20">
            <span className="big-border"></span>
          </div>
        </ShowIf>
        <ShowIf condition={this.props.role != 'truongPhongKiemTraDeXuat'}>
          <h2 className="title-14 mb15">Thông tin giải quyết</h2>
        </ShowIf>
        <ShowIf condition={this.props.role == 'truongPhongKiemTraDeXuat'}>
          <h2 className="title-14 mb15">Thông tin đề xuất</h2>
        </ShowIf>
        <form className="form-action">
          <div className="row pl10 pr10">
            <ShowIf condition={this.props.role == 'truongPhongKiemTraDeXuat'}>
              <div className="col-100 mb10">
                <span className="val-title-inline-bold">Phòng: &nbsp;</span>
                <span className='val-content-inline'>{typeof this.state.coQuanQuanLyNguoiDung != 'undefined' ? this.state.coQuanQuanLyNguoiDung.ten : ''}</span>
              </div>
            </ShowIf>
            <ShowIf condition={this.state.role == 'truongPhongTTXM'}>
              <Text label='Phòng ban:' value={typeof this.state.coQuanQuanLyNguoiDung != 'undefined' ? this.state.coQuanQuanLyNguoiDung.ten : ''}/>
            </ShowIf>
            <Text label='Công chức giải quyết:' value={this.state.data.canBoXuLyChiDinhInfo ? this.state.data.canBoXuLyChiDinhInfo.hoVaTen : ''}/>
            <ShowIf condition={this.props.role == 'truongPhongGiaiQuyetDon'}>
              <Text label='Thời hạn giải quyết:' red={true} value={this.state.data.thongTinGiaiQuyetDonInfo && this.state.data.thongTinGiaiQuyetDonInfo.ngayHetHanGiaiQuyet ? moment(this.state.data.thongTinGiaiQuyetDonInfo.ngayHetHanGiaiQuyet).format('DD/MM/YYYY') : ''}/>
            </ShowIf>
            <ShowIf condition={this.props.role == 'truongPhongKiemTraDeXuat'}>
              <Text label='Hạn xử lý:' red={true} value={this.state.data.thongTinGiaiQuyetDonInfo && this.state.data.thongTinGiaiQuyetDonInfo.ngayHetHanKTDX ? moment(this.state.data.thongTinGiaiQuyetDonInfo.ngayHetHanKTDX).format('DD/MM/YYYY') : ''}/>
            </ShowIf>
            <ShowIf condition={this.props.loaiDon == 'DON_TO_CAO' && this.props.role == 'truongPhongGiaiQuyetDon'}>
              <Text value={this.state.ngayHetHanSauKhiGiaHanGiaiQuyet} red={true} className="col-25" label="Gia hạn đến ngày:" />
            </ShowIf>
            <ShowIf condition={this.props.loaiDon == 'DON_KHIEU_NAI' && this.props.role == 'truongPhongGiaiQuyetDon'}>
              <Text value={this.state.ngayHetHanSauKhiGiaHanTTXM} red={true} className="col-25" label="Gia hạn đến ngày:" />
            </ShowIf>
            <TextMessage className="col-100 mt5 mb5" label='Ý kiến xử lý:' value={this.state.data.yKienGiaiQuyet}/>
            <div className="col-100 pb5">
              <ContainerFileDinhKem label="Danh sách văn bản xử lý" hideDescription={true} bindValidator={this} dataShow={this.props.listTaiLieuVanThuGiaiQuyetDon} disableAttachFile={true}/>
            </div>
          </div>
          <div className="box-bottom">
            <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
          </div>
        </form>
      </section>
    );
  }
}

export default KetQuaGiaiQuyetDonTruongPhong;


// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/KetQuaGiaiQuyetDonTruongPhong.jsx